import { IonCheckbox, IonImg } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocaleStore } from '@davi-ai/retorik-framework'
import { updateFilters } from '../features/mapSlice'
import { POIType } from '../models/POI'
import type { RootState } from '../stores/globalStore'
import oumanger from '../styles/icons/filter_oumanger.png'
import hebergement from '../styles/icons/filter_oudormir.png'
import afaire from '../styles/icons/filter_afaire.png'
import avoir from '../styles/icons/filter_avoir.png'
import produit from '../styles/icons/filter_produit.png'
import service from '../styles/icons/filter_service.png'
import '../styles/components/MapFilter.scss'
import translation from '../translations/mapFilter.json'
import { MapLabel, MapSettings } from '../models/Map'

interface MapFilterProps {
  settings?: MapSettings
}

const MapFilter = (props?: MapFilterProps | undefined): JSX.Element => {
  const dispatch = useDispatch()
  const locale = useLocaleStore((state) => state.locale)
  const [toggle, setToggle] = useState<boolean>(true)
  const currentFilter = useSelector(
    (state: RootState) => state.map.currentFilter
  )
  /* const currentTenant = useSelector(
    (state: RootState) => state.tenant.activeTenant
  ) */
  const displayFilter = useSelector((state: RootState) => state.map.showFilters)

  const [showFilters, setShowFilters] = useState<Array<POIType>>([
    POIType.afaire,
    POIType.avoir,
    POIType.hebergement,
    POIType.produit,
    POIType.service
  ])

  const [labelTranslated, setLabelTranslated] = useState<{
    [locale: string]: MapLabel
  }>(translation)

  useEffect(() => {
    if (props?.settings && props?.settings.showFilter) {
      setShowFilters(props?.settings?.showFilter)
    }

    // Handle translation
    if (
      props?.settings?.labelFilter &&
      Object.keys(props?.settings?.labelFilter).length > 0
    ) {
      setLabelTranslated(props.settings.labelFilter)
    } else {
      setLabelTranslated(translation)
    }
  }, [props])

  function checkboxClick(_e: any, type: string): void {
    let check = false
    const currentCheckBox = _e?.parentElement?.querySelector(`#${type}`)
    let copyFilter: POIType[] = [...currentFilter]
    if (currentCheckBox) {
      currentCheckBox.ariaChecked =
        currentCheckBox.ariaChecked === 'true' ? 'false' : 'true'
      check = currentCheckBox.ariaChecked === 'true'
      console.log(currentCheckBox)
      console.log('check', check)
      // Hack for defautl checked
      if (type === POIType.avoir) {
        copyFilter = copyFilter.filter((f) => f !== type)
        ;(currentCheckBox as HTMLIonCheckboxElement).checked = false
      }
    }

    if (check === true) {
      if (!copyFilter.some((f) => f === type)) {
        copyFilter.push(type as POIType)
        dispatch(updateFilters({ currentFilter: copyFilter }))
      }
    } else if (check === false) {
      dispatch(
        updateFilters({ currentFilter: copyFilter.filter((f) => f !== type) })
      )
    }
    console.log('Pushed filter', copyFilter)
  }

  return (
    <>
      {displayFilter && (
        <div className={`filterContainer  ${toggle ? 'show' : 'hide'}`}>
          <div
            className='filterToggler'
            onClick={(): void => setToggle(!toggle)}>
            {labelTranslated[locale]?.title || labelTranslated['fr-FR'].title}
            <span className={`arrow ${toggle ? 'active' : ''}`} />
          </div>
          <div className='filterMenu'>
            {showFilters.indexOf(POIType.afaire) > -1 && (
              <div
                className={`filterCategory ${
                  currentFilter.some((f) => f === POIType.afaire)
                    ? 'selectedFilter'
                    : ''
                }
                    `}
                onClick={(e): void => checkboxClick(e.target, POIType.afaire)}>
                <IonCheckbox
                  id={POIType.afaire}
                  checked={currentFilter.some((f) => f === POIType.afaire)}
                  placeholder={undefined}
                />
                <IonImg
                  src={afaire}
                  className='bg_red'
                  placeholder={undefined}
                />
                <span className='cl_red'>
                  {labelTranslated[locale]?.whattodo ||
                    labelTranslated['fr-FR'].whattodo}
                </span>
              </div>
            )}
            {showFilters.indexOf(POIType.restaurant) > -1 && (
              <div
                className={`filterCategory ${
                  currentFilter.some((f) => f === POIType.restaurant)
                    ? 'selectedFilter'
                    : ''
                }`}
                onClick={(e): void =>
                  checkboxClick(e.target, POIType.restaurant)
                }>
                <IonCheckbox
                  id={POIType.restaurant}
                  checked={currentFilter.some((f) => f === POIType.restaurant)}
                  placeholder={undefined}
                />
                <IonImg
                  src={oumanger}
                  className='bg_orange'
                  placeholder={undefined}
                />
                <span className='cl_orange'>
                  {labelTranslated[locale]?.wheretoeat ||
                    labelTranslated['fr-FR'].wheretoeat}
                </span>
              </div>
            )}
            {showFilters.indexOf(POIType.hebergement) > -1 && (
              <div
                className={`filterCategory ${
                  currentFilter.some((f) => f === POIType.hebergement)
                    ? 'selectedFilter'
                    : ''
                }`}
                onClick={(e): void =>
                  checkboxClick(e.target, POIType.hebergement)
                }>
                <IonCheckbox
                  id={POIType.hebergement}
                  checked={currentFilter.some((f) => f === POIType.hebergement)}
                  placeholder={undefined}
                />
                <IonImg
                  src={hebergement}
                  className='bg_purple'
                  placeholder={undefined}
                />
                <span className='cl_purple'>
                  {labelTranslated[locale]?.wheretosleep ||
                    labelTranslated['fr-FR'].wheretosleep}
                </span>
              </div>
            )}
            {showFilters.indexOf(POIType.avoir) > -1 && (
              <div
                className={`filterCategory ${
                  currentFilter.some((f) => f === POIType.avoir)
                    ? 'selectedFilter'
                    : ''
                }`}
                onClick={(e): void => checkboxClick(e.target, POIType.avoir)}>
                <IonCheckbox
                  id={POIType.avoir}
                  checked={currentFilter.some((f) => f === POIType.avoir)}
                  placeholder={undefined}
                />
                <IonImg
                  src={avoir}
                  className='bg_green'
                  placeholder={undefined}
                />
                <span className='cl_green'>
                  {labelTranslated[locale]?.whattosee ||
                    labelTranslated['fr-FR'].whattosee}
                </span>
              </div>
            )}
            {showFilters.indexOf(POIType.produit) > -1 && (
              <div
                className={`filterCategory ${
                  currentFilter.some((f) => f === POIType.produit)
                    ? 'selectedFilter'
                    : ''
                }`}
                onClick={(e): void => checkboxClick(e.target, POIType.produit)}>
                <IonCheckbox
                  id={POIType.produit}
                  checked={currentFilter.some((f) => f === POIType.produit)}
                  placeholder={undefined}
                />
                <IonImg
                  src={produit}
                  className='bg_light_green'
                  placeholder={undefined}
                />
                <span className='cl_light_green'>
                  {labelTranslated[locale]?.localproducts ||
                    labelTranslated['fr-FR'].localproducts}
                </span>
              </div>
            )}
            {showFilters.indexOf(POIType.service) > -1 && (
              <div
                className={`filterCategory ${
                  currentFilter.some((f) => f === POIType.service)
                    ? 'selectedFilter'
                    : ''
                }`}
                onClick={(e): void => checkboxClick(e.target, POIType.service)}>
                <IonCheckbox
                  id={POIType.service}
                  checked={currentFilter.some((f) => f === POIType.service)}
                  placeholder={undefined}
                />
                <IonImg
                  src={service}
                  className='bg_blue'
                  placeholder={undefined}
                />
                <span className='cl_blue'>
                  {labelTranslated[locale]?.services ||
                    labelTranslated['fr-FR'].services}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export { MapFilter }
